import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { RoadmapTimeline } from "@/components/product/RoadmapTimeline";
import { PlatformFeatures } from "@/components/product/PlatformFeatures";
import { VideoHero } from "@/components/product/VideoHero";
import { StakeholderCarousels } from "@/components/StakeholderCarousels";

const advancedFeatures = [
  {
    title: "Hotel AI Consultant",
    description:
      "A 24/7 virtual consultant providing tailored recommendations for optimizing hotel operations, procurement, and guest experience.",
    gif: "/supplyfied-upload/AIConsultant.gif",
  },
  {
    title: "Bidding System",
    description:
      "An intelligent platform that connects hotels with suppliers, enabling transparent, competitive bidding to ensure cost-effectiveness and quality.",
    gif: "/supplyfied-upload/customerplat.gif",
  },
  {
    title: "Hotel Classifier",
    description:
      "A cutting-edge solution for automating hotel classification based on regulatory and quality standards, ensuring compliance and improved guest experiences.",
    gif: "/supplyfied-upload/score.gif",
  },
  {
    title: "Order Fulfillment",
    description:
      "End-to-end management of the supply chain process, from order placement to delivery, ensuring on-time, accurate, and efficient operations.",
    gif: "/supplyfied-upload/orderful.gif",
  },
];

const Product = () => {
  return (
    <div className="bg-primary/5">
      {/* Hero Section - Standalone */}
      <section className="w-full">
        <div className="max-w-7xl mx-auto p-6 bg-slate-900 relative overflow-hidden">
          {/* Subtle animated background effects */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/10 via-purple-900/5 to-blue-900/10 animate-pulse"></div>
          <div className="absolute top-0 left-0 w-32 h-32 bg-blue-500/5 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-purple-500/5 rounded-full blur-3xl animate-pulse"></div>
          <div className="relative z-10">
            <VideoHero
              videoSrc="/supplyfied-upload/MT%20Video%20Final.mp4.MP4"
              title="Supplyfied Platform"
              description="Revolutionizing hospitality supply chain management with AI-powered solutions"
            />
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="w-full">
        <div className="max-w-7xl mx-auto p-6 space-y-12">
          <StakeholderCarousels />

          <Card>
            <CardHeader>
              <CardTitle className="text-xl text-primary">
                Advanced Platform Capabilities
              </CardTitle>
            </CardHeader>
            <CardContent>
              <PlatformFeatures title="" features={advancedFeatures} />
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-xl text-primary">
                Technology Roadmap
              </CardTitle>
            </CardHeader>
            <CardContent>
              <RoadmapTimeline />
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Product;
